import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "@/components/Logo";

const Preloader = () => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 1400);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="site-preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } }}
          className="fixed inset-0 z-[100] bg-paper flex items-center justify-center"
        >
          <div className="w-[320px] md:w-[440px] text-center">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } }}
            >
              <Logo size="lg" className="mx-auto" data-testid="preloader-logo" />
            </motion.div>
            <div className="mt-8 preload-bar" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
